import TaskRankingsPage from "./TaskRankingsPage";

export default TaskRankingsPage;